import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Style from 'ol/style/Style'
import Fill from 'ol/style/Fill'
import Stroke from 'ol/style/Stroke'
import Circle from 'ol/style/Circle'
import Draw from 'ol/interaction/Draw'
import Overlay from 'ol/Overlay'
import * as olSphere from 'ol/sphere'
import Polygon from 'ol/geom/Polygon'
import LineString from 'ol/geom/LineString'
import Observable from 'ol/Observable'
/**
 * 测量工具
 * @author xunyi
 */
var MeasureTools = (function () {
  function MeasureTools (map2d) {
    this.first = true
    this.init(map2d)
    this.Observable = new Observable()
  }
  MeasureTools.prototype = {
    /**
         * 初始化
         * @param {Object} map2d 地图对象
         */
    init (map2d) {
      this.canvas = new VectorSource()
      var vector = new VectorLayer({
        source: this.canvas,
        style: new Style({
          fill: new Fill({ color: 'rgba(255, 255, 255, 0.2)' }),
          stroke: new Stroke({ color: '#ffcc33', width: 2 }),
          image: new Circle({ radius: 7, fill: new Fill({ color: '#ffcc33' }) })
        }),
        zIndex: map2d.layerLevel.draw
      })
      map2d.map.addLayer(vector)
    },
    /**
         * 启动测量
         * @param {Object} map2d 地图对象
         * @param {String} type 测量类型
         */
    start (map2d, type) {
      const _this = this
      const mapObject = map2d.map
      if (_this.draw !== undefined) {
        mapObject.removeInteraction(_this.draw)
      }
      _this.addInteraction(mapObject, type)
      if (_this.first) {
        // 鼠标滑过
        _this.pointerMoveHandler = function (evt) {
          if (evt.dragging) {
            return
          }
          var helpMsg = '单击开始绘制'
          if (_this.sketch) {
            var geom = (_this.sketch.getGeometry())
            if (geom instanceof Polygon) {
              helpMsg = '点击继续绘制多边形'
            } else if (geom instanceof LineString) {
              helpMsg = '单击继续画线，双击计算结果'
            }
          }
          _this.helpTooltipElement.innerHTML = helpMsg
          _this.helpTooltip.setPosition(evt.coordinate)
          _this.helpTooltipElement.classList.remove('runbir-hidden')
        }
        _this.mouseout = function () {
          _this.helpTooltipElement.classList.add('runbir-hidden')
        }
        mapObject.on('pointermove', _this.pointerMoveHandler)
        mapObject.getViewport().addEventListener('mouseout', _this.mouseout)
        _this.first = false
      }
    },
    stop (map2d) {
      const mapObject = map2d.map
      mapObject.removeInteraction(this.draw)
      mapObject.un('pointermove', this.pointerMoveHandler)
      mapObject.getViewport().removeEventListener('mouseout', this.mouseout)
      this.helpTooltipElement.innerHTML = ''
      this.first = true
    },
    /**
         * 调用加载绘制交互控件的方法，添加绘图进行测量
         * @param {Object} mapObject 地图对象
         * @param {String} type 测量类型
         */
    addInteraction (mapObject, type) {
      this.draw = new Draw({
        source: this.canvas,
        type: type,
        style: new Style({
          fill: new Fill({ color: 'rgba(255, 255, 255, 0.2)' }),
          stroke: new Stroke({ color: 'rgba(255, 255, 255, 0.5)', lineDash: [10, 10], width: 2 }),
          image: new Circle({
            radius: 5,
            stroke: new Stroke({ color: 'rgba(0, 0, 0, 0.7)' }),
            fill: new Fill({ color: 'rgba(255, 255, 255, 0.2)' })
          })
        })
      })
      mapObject.addInteraction(this.draw)
      this.createMeasureTooltip(mapObject)
      this.createHelpTooltip(mapObject)
      this.drawstart()
      this.drawend(mapObject)
    },
    drawstart () {
      const _this = this
      _this.draw.on('drawstart', function (evt) {
        _this.sketch = evt.feature
        var tooltipCoord = evt.coordinate
        _this.listener = _this.sketch.getGeometry().on('change', function (evt) {
          var geom = evt.target
          var output
          if (geom instanceof Polygon) {
            output = _this.getArea(geom)
            tooltipCoord = geom.getInteriorPoint().getCoordinates()
          } else if (geom instanceof LineString) {
            output = _this.getLength(geom)
            tooltipCoord = geom.getLastCoordinate()
          } else {
            console.log('目前支持Polygon和LineString')
          }
          _this.measureTooltipElement.innerHTML = output
          _this.measureTooltip.setPosition(tooltipCoord)
        })
      }, this)
    },
    /**
         *
         * @param {Object} mapObject 地图对象
         */
    drawend (mapObject) {
      const _this = this
      _this.draw.on('drawend', function (evt) {
        var element = _this.measureTooltip.getElement()
        var position = _this.measureTooltip.getPosition()
        mapObject.removeOverlay(_this.measureTooltip)
        _this.sketch = null
        _this.measureTooltipElement = null
        _this.createMeasureTooltip(mapObject)
        _this.Observable.un(evt.type, _this.listener)

        element.className = 'runbir-tooltip runbir-tooltip-static'
        var meTooltip = new Overlay({
          element: element,
          offset: [0, -7],
          positioning: 'bottom-center',
          position: position
        })
        mapObject.addOverlay(meTooltip)

        var deleteDraw = document.createElement('a')
        deleteDraw.className = 'runbir-draw-delete'
        deleteDraw.href = 'javascript:void(0);'
        deleteDraw.innerHTML = 'X'
        var deleteOverlay = new Overlay({
          element: deleteDraw,
          offset: [0, 25],
          positioning: 'bottom-center',
          position: position
        })
        mapObject.addOverlay(deleteOverlay)
        var feature = evt.feature
        deleteDraw.addEventListener('click', function () {
          _this.canvas.removeFeature(feature)
          mapObject.removeOverlay(deleteOverlay)
          mapObject.removeOverlay(meTooltip)
        })
      }, this)
    },
    /**
         * 创建测量结果
         * @param {Object} mapObject 地图对象
         */
    createMeasureTooltip (mapObject) {
      const _this = this
      if (_this.measureTooltipElement) {
        _this.measureTooltipElement.parentNode.removeChild(_this.measureTooltipElement)
      }
      _this.measureTooltipElement = document.createElement('div')
      _this.measureTooltipElement.className = 'runbir-tooltip runbir-tooltip-measure'
      _this.measureTooltip = new Overlay({
        element: _this.measureTooltipElement,
        offset: [0, -15],
        positioning: 'bottom-center'
      })
      mapObject.addOverlay(_this.measureTooltip)
    },
    /**
         * 创建测量帮助信息
         * @param {Object} mapObject 地图对象
         */
    createHelpTooltip (mapObject) {
      const _this = this
      if (_this.helpTooltipElement) {
        _this.helpTooltipElement.parentNode.removeChild(_this.helpTooltipElement)
      }
      _this.helpTooltipElement = document.createElement('div')
      _this.helpTooltipElement.className = 'runbir-tooltip runbir-hidden'
      _this.helpTooltip = new Overlay({
        element: _this.helpTooltipElement,
        offset: [15, 0],
        positioning: 'center-left'
      })
      mapObject.addOverlay(_this.helpTooltip)
    },
    /**
         * 获取距离
         * @param {ol.geom.LineString} line
         */
    getLength (line) {
      const options = { projection: 'EPSG:4326' }
      var length = olSphere.getLength(line, options)
      var output
      if (length > 100) {
        output = (Math.round(length / 1000 * 100) / 100) +
                    ' ' + 'km'
      } else {
        output = (Math.round(length * 100) / 100) +
                    ' ' + 'm'
      }
      return output
    },
    /**
         * 获取面积
         * @param {ol.geom.Polygon} polygon
         */
    getArea (polygon) {
      const options = { projection: 'EPSG:4326' }
      var area = olSphere.getArea(polygon, options)
      var output
      if (area > 10000) {
        output = (Math.round(area / 1000000 * 100) / 100) +
                    ' ' + 'km<sup>2</sup>'
      } else {
        output = (Math.round(area * 100) / 100) +
                    ' ' + 'm<sup>2</sup>'
      }
      return output
    }
  }
  return MeasureTools
}())
export default MeasureTools
